import { render, staticRenderFns } from "./OtherReceiptPaymentPrintout.vue?vue&type=template&id=4ad778e0"
import script from "./OtherReceiptPaymentPrintout.vue?vue&type=script&lang=js"
export * from "./OtherReceiptPaymentPrintout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports